var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndvideoRedWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 99,
    viewBox: "0 0 1440 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.83871C36.9559 0.339142 74.0046 -3.11598 110.4 6.93634C147.2 17.1004 184 40.9134 221.12 52.7231C258.08 64.5327 295.52 64.1455 332.48 54.3687C369.6 44.495 406.4 25.1348 443.2 18.6492C510.367 6.98828 597.082 20.658 664.32 30.6525C701.28 36.0733 738.72 47.1086 775.68 50.9807C812.8 54.8527 849.6 51.5615 886.4 46.915C923.2 42.2686 960 36.0733 996.8 28.3293C1033.6 20.5852 1070.4 11.2924 1107.52 7.22673C1144.48 3.1611 1181.92 4.51631 1218.88 15.4548C1256 26.3933 1292.8 47.1086 1329.6 49.6254C1368.68 52.4011 1404.86 36.0522 1440 21.2628V99.0004C960 99.0004 480 99.0004 0 99.0004V3.83871Z",
    fill: "#EF6D56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndvideoRedWave);
export default __webpack_public_path__ + "static/media/endvideo-red-wave.5a215ba59ac5abe228d4c207710da11c.svg";
export { ForwardRef as ReactComponent };